/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { CustomAttributeValue, CustomAttributeValues } from '../../customAttributes/customAttributeValue';
import { SLTXFormatRootFileGroup } from '../../fileFormats/sltx/sltx';
import { PriceData } from '../../fileFormats/catalog/catalog';
import { TreeOptionSelections } from '../../modelConfiguration/data/optionsSelection';
import { SLTXTranslations } from '../../fileFormats/sltx/sltxTranslations';
import { SLTXFile } from '../../fileFormats/sltx/sltxFile';
import { CustomAttributeData } from '../../customAttributes/customAttributes';
import { useAppSelector } from '../../../../Redux/Store/hooks';
import { ConditionEvaluator } from '../../modelConfiguration/rules/rulesConditionEvaluator';
import { ConditionalRangeRuleSet } from '../../customAttributes/customAttributesConditionalRanges';
import { CustomAttributeType } from '../../customAttributes/customAttributeType';

import { CustomAttributeClassPrefix } from '../../customAttributes/customAttributesClassPrefix';
import { ComponentCustomAttributeOption } from '../customAttributes/controls/customAttributeOption';
import { ComponentCustomAttributeBoolean } from '../customAttributes/controls/customAttributeBoolean';
import { ComponentCustomAttributeText } from '../customAttributes/controls/customAttributeText';
import { ComponentCustomAttributeInteger } from '../customAttributes/controls/customAttributeInteger';
import { ComponentCustomAttributeDecimal } from '../customAttributes/controls/customAttributeDecimal';
import { IframePopupComponent } from '../message/iframePopup';
import { RulesEvaluationHelpers } from '../../modelConfiguration/rules/rulesEvaluationHelpers';

interface ModelConfigurationLinearCustomAttributesParameters {
  // eslint-disable-next-line react/require-default-props
  className?: string,
  // Base sltx files with the mode information (inc. CustAttributesData)
  sltxFile: SLTXFile | undefined;
  // Current item component/options settings
  selectedOptions: TreeOptionSelections | undefined
  // Custome Attributes deifinition
  customAttributes: CustomAttributeData[],
  // Current Values of the item's custom Attibutes
  customAttributesValues: CustomAttributeValues,
  // Price Settings
  priceData: PriceData[] | undefined,
  // Language selected form translation in UI
  languageSelected: string,
  // Function to change custom attributes values
  changeCustomAttributesHandler: (attributes: CustomAttributeValues) => void;
  // Check for extras (i.e. ignore extra attributes in this list)
  bCheckForExtras?: boolean,
}

export function ModelConfigurationLinearCustomAttributes({
  className = 'model-tree',
  sltxFile,
  selectedOptions,
  customAttributes,
  customAttributesValues,
  priceData,
  languageSelected,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeCustomAttributesHandler,
  bCheckForExtras = true,
} : ModelConfigurationLinearCustomAttributesParameters) {

  const [iframeSrc, setIframeSrc] = React.useState(''); // Initial iframe source must be empty
  const [iframeTitle, setIframeTitle] = React.useState('Info');

  const isOptioValueActive = (
    optioValue: string,
  ) : boolean => {
    return (optioValue !== 'No'
      && optioValue !== 'None'
      && optioValue !== 'false');
  };

  const lang: string = languageSelected;

  const getSelectedOptionForComponent = (component: SLTXFormatRootFileGroup, translate: boolean) => {
    if (!selectedOptions) return '<undefined-00>';
    const selectedComponent = selectedOptions.find((opt) => opt.groupID === component.id);

    if (sltxFile && selectedComponent) return SLTXTranslations.getSelectedOptionTranslation(component.id, selectedComponent.optionID, sltxFile, translate, lang);
    return '<undefined-01>';
  };

  const getSelecteOptionFromGroupExtendedBy = (extraAttr : CustomAttributeData) : string | undefined => {
    let value = '';
    if (!sltxFile) return undefined;

    const doMatch = sltxFile.getRootFileContents()?.groups?.some((component) => {
      value = getSelectedOptionForComponent(component, false);
      return CustomAttributeData.isExtenderOf(extraAttr, component.name);
    });
    if (doMatch) {
      return value;
    }
    return undefined;
  };

  // From the store, get the strings
  const strings = useAppSelector((state) => {
    return state.TextsReducer.strings;
  })!;

  const evalMyDependants = (attrKey: string) : string[] => {
    let dependants : string [] = [];

    customAttributes.forEach((att) => {
      if (att.key && att.condition && att.condition.trim()) {
        if (ConditionEvaluator.dependsOn(att.condition, attrKey)) dependants.push(att.key);
      }
    });
    if (customAttributes !== undefined) {
      const conditionalRangeDependents = ConditionalRangeRuleSet.getOrderedDeepDependants(customAttributes || [], attrKey);
      const rangeDepKeys = conditionalRangeDependents.map((c) => { return c.key || '???'; });
      if (rangeDepKeys) dependants = [...dependants, ...rangeDepKeys]; // Concat enabling condition dependants and the range ones
    }
    return dependants;
  };

  // ----------------------------------------------------------------------------------------------
  // Can Checkout controlling the enabling of the "Add 2 Cart" button
  // ----------------------------------------------------------------------------------------------
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [canCheckout, setCanCheckout] = useState(true);

  // ----------------------------------------------------------------------------------------
  // Check if all mandatory attrs were set and call setCanCheckOut accrodingly
  // -----------------------------------------------------------------------------------------
  useEffect(() => {
    let isCheckoutActive = true;

    customAttributes.forEach((att) => {
      if (att.isMandatory) {
        const savedAttribute = customAttributesValues.find((satt) => satt.attributeKey === att.key);
        // eslint-disable-next-line max-len
        if (savedAttribute?.attributeEnabled
          && (savedAttribute?.attributeKey === undefined
            || savedAttribute?.attributeValue === undefined
            || savedAttribute?.attributeValue === '')) {
          isCheckoutActive = false;
        }
      }
    });

    setCanCheckout(isCheckoutActive);
  }, [customAttributesValues]);

  const updateAttrVisibiltyAndValue = () => {
    const newAttributes : CustomAttributeValues = [];
    customAttributes.forEach((attrdata) => {

      const oldDepAttribute = customAttributesValues.find((att) => att.attributeKey === attrdata.key);
      if (oldDepAttribute && attrdata) {
        const bIsAttributeEnabled = RulesEvaluationHelpers.checkAttrCondition(
          attrdata.condition,
          RulesEvaluationHelpers.getVarValuesFromComposition(sltxFile, selectedOptions),
          customAttributesValues,
        );

        // Cap value as per the Range Rule Set (if anny)
        let attrValue = ConditionalRangeRuleSet.capValue(
          oldDepAttribute.attributeValue,
          attrdata,
          [...newAttributes, ...customAttributesValues], // Make sure already updated attrs go first in order to influence their dependants
        );

        let newQuantity2set = -1;
        if (attrdata.hasQuantity) {
          newQuantity2set = bIsAttributeEnabled ? oldDepAttribute.attributeQuantity : 0;
        }

        if (!bIsAttributeEnabled) {
          switch (attrdata.type) {
            case CustomAttributeType.Text:
              attrValue = '';
              break;
            case CustomAttributeType.Boolean:
              attrValue = 'false';
              break;
            case CustomAttributeType.Decimal:
              attrValue = '0.0';
              break;
            case CustomAttributeType.Integer:
              attrValue = '0';
              break;
            case CustomAttributeType.Option:
              attrValue = '';
              break;
            default:
              attrValue = oldDepAttribute.attributeValue;
          }
        }

        newAttributes.push({
          attributeKey: oldDepAttribute.attributeKey,
          attributeName: oldDepAttribute.attributeName,
          attributeValue: attrValue,
          attributeTranslatedValue: CustomAttributeData.getTranslatedOption(oldDepAttribute.attributeValue, attrdata),
          attributeQuantity: newQuantity2set,
          attributeBasePrice: attrdata.basePrice,
          attributeEnabled: bIsAttributeEnabled,
        });
      }
    });
    changeCustomAttributesHandler([...newAttributes]);
  };

  useEffect(() => {
    updateAttrVisibiltyAndValue();
  }, [selectedOptions]);

  const initAttrValues = () => {
    if (customAttributesValues.length === 0 && customAttributes) {
      // TODO PMC: Change and add prio, type, hasQUantity (and eventually a translation of the name)
      const stateAttributes = new Array<CustomAttributeValue>();
      customAttributes.forEach((att) => {
        if (att?.key && att?.name) {
          let value = '';
          if (att.type === CustomAttributeType.Option
            && att.propertiesOption
            && att.propertiesOption.options
            && att.propertiesOption.options.length > 0) {
            // eslint-disable-next-line prefer-destructuring
            value = att.propertiesOption.options[0];
          } else if (att.type === CustomAttributeType.Boolean) {
            value = 'false';
          }
          let defaultQuant = CustomAttributeData.getAttributeQuantity(att, undefined, value);
          const matchiOptionValue = getSelecteOptionFromGroupExtendedBy(att);
          if (matchiOptionValue !== undefined) {
            if (isOptioValueActive(matchiOptionValue)) {
              if (att.type === CustomAttributeType.Text) {
                value = matchiOptionValue;
                defaultQuant = 1;
              }
            } else {
              value = 'false';
              defaultQuant = 0;
            }
          }

          const stateAtt: CustomAttributeValue = new CustomAttributeValue({
            attributeKey: att?.key,
            attributeName: att?.name,
            attributeValue: value,
            attributeTranslatedValue: CustomAttributeData.getTranslatedOption(value, att),
            attributeQuantity: defaultQuant,
            attributeBasePrice: att?.basePrice,
            attributeEnabled: RulesEvaluationHelpers.checkAttrCondition(
              att?.condition,
              RulesEvaluationHelpers.getVarValuesFromComposition(sltxFile, selectedOptions),
              [...stateAttributes, ...customAttributesValues],
            ),
          });
          stateAttributes.push(stateAtt);
        }
      });
      const updateStateAttributes = RulesEvaluationHelpers.evalConditions(
        RulesEvaluationHelpers.getVarValuesFromComposition(sltxFile, selectedOptions),
        sltxFile?.getRootFileContents()?.customAttributes || [],
        stateAttributes,
      );
      changeCustomAttributesHandler([...(updateStateAttributes || stateAttributes)]);
    }
  };
  // ----------------------------------------------------------------------------------------
  // Init the custom attribute values settting their default values and quantities
  // ----------------------------------------------------------------------------------------
  useEffect(() => {
    initAttrValues();
  }, []);

  const getAttributeQuantity = function (key: string | undefined, requestedValue: string) : number | undefined {
    if (key === undefined) {
      return -1;
    }
    const attribute = customAttributes.find((att) => att.key === key);
    const oldAttributeValue = customAttributesValues.find((attV) => attV.attributeKey === key);
    return CustomAttributeData.getAttributeQuantity(attribute, oldAttributeValue, requestedValue);
  };

  const getAttributeValue = (key: string | undefined) : string => {
    if (key === undefined) {
      return '';
    }
    const oldAttribute = customAttributesValues.find((attV) => attV.attributeKey === key);
    if (oldAttribute !== undefined) {
      return oldAttribute.attributeValue;
    }
    return '';
  };

  const fillAttributeQuantity = function (value: number, key: string | undefined) {

    if (key === undefined) {
      return;
    }

    const attribute = customAttributes.find((att) => att.key === key);
    if (attribute === undefined) {
      return;
    }

    if (attribute.hasQuantity) {
      if (!Number(value)) return;
      if (+value < 0) return;
    }

    const quantity2set = attribute.hasQuantity ? value : -1;

    if (attribute.key && attribute.name) {
      const oldAttribute = customAttributesValues.find((att) => att.attributeKey === attribute.key);
      const newAttributes = customAttributesValues.filter((att) => att.attributeKey !== attribute.key);
      newAttributes.push({
        attributeKey: attribute.key,
        attributeName: attribute.name,
        attributeValue: oldAttribute !== undefined ? oldAttribute.attributeValue : '',
        attributeTranslatedValue: oldAttribute !== undefined ? oldAttribute.attributeTranslatedValue : '',
        attributeQuantity: quantity2set,
        attributeBasePrice: attribute.basePrice,
        attributeEnabled: RulesEvaluationHelpers.checkAttrCondition(
          attribute.condition,
          RulesEvaluationHelpers.getVarValuesFromComposition(sltxFile, selectedOptions),
          customAttributesValues,
        ),
      });
      changeCustomAttributesHandler([...newAttributes]);
    }
  };

  // ----------------------------------------------------------------------------------------
  // Update the customAttributes (called by attr components::onValueChange)
  // ----------------------------------------------------------------------------------------
  const fillAttributeValue = function (value: string, key: string | undefined) {
    if (key === undefined) {
      return;
    }
    const attribute = customAttributes.find((att) => att.key === key);
    if (attribute === undefined) {
      return;
    }

    if (attribute.type === CustomAttributeType.Integer) {
      if (!Number(+value)) return;
      if (attribute.propertiesInteger?.maxValue && +value > attribute.propertiesInteger.maxValue) return;
      if (attribute.propertiesInteger?.minValue && +value < attribute.propertiesInteger.minValue) return;
    }

    if (attribute.type === CustomAttributeType.Decimal) {
      if (!Number(+value)) return;
      if (attribute.propertiesDecimal?.maxValue && +value > attribute.propertiesDecimal.maxValue) return;
      if (attribute.propertiesDecimal?.minValue && +value < attribute.propertiesDecimal.minValue) return;
    }

    if (attribute.key && attribute.name) {
      // ----------------------------------------------------------------------------------------
      // Get an ordered list of the dependants, making sure that master attributes
      // come before their dependants (inter-dependances between the dependants)
      // ----------------------------------------------------------------------------------------
      const attrDependants = evalMyDependants(key);
      // ----------------------------------------------------------------------------------------
      // The mew attributes are: the one changed by the user plus all its dependants
      // ----------------------------------------------------------------------------------------
      const newAttributes = customAttributesValues.filter((att) => {
        const isDependent = attrDependants.find((k) => k === att.attributeKey);
        return att.attributeKey !== attribute.key && !isDependent;
      });

      // ----------------------------------------------------------------------------------------
      // First let's add the changed one...
      // ----------------------------------------------------------------------------------------
      const oldAttribute = customAttributesValues.find((att) => att.attributeKey === attribute.key);
      let quantity2set = -1;
      if (attribute.hasQuantity) {
        quantity2set = CustomAttributeData.getAttributeQuantity(attribute, oldAttribute, value);
      }

      newAttributes.push({
        attributeKey: attribute.key,
        attributeName: attribute.name,
        attributeValue: value,
        attributeTranslatedValue: CustomAttributeData.getTranslatedOption(value, attribute),
        attributeQuantity: quantity2set,
        attributeBasePrice: attribute.basePrice,
        attributeEnabled: RulesEvaluationHelpers.checkAttrCondition(
          attribute.condition,
          RulesEvaluationHelpers.getVarValuesFromComposition(sltxFile, selectedOptions),
          customAttributesValues,
        ),
      });

      // ----------------------------------------------------------------------------------------
      // And then the dependants, defaulting their values in case they became disabled
      // or  their  updated ranges invalidate the current value
      // ----------------------------------------------------------------------------------------
      attrDependants.forEach((depKey) => {
        const oldDepAttribute = customAttributesValues.find((att) => att.attributeKey === depKey);
        const oldDepAttrType = customAttributes.find((att) => att.key === depKey);
        if (oldDepAttribute && oldDepAttrType) {
          const bIsAttributeEnabled = RulesEvaluationHelpers.checkAttrCondition(
            oldDepAttrType.condition,
            RulesEvaluationHelpers.getVarValuesFromComposition(sltxFile, selectedOptions),
            [...newAttributes, ...customAttributesValues],
          );

          // Cap value as per the Range Rule Set (if anny)
          let attrValue = ConditionalRangeRuleSet.capValue(
            oldDepAttribute.attributeValue,
            oldDepAttrType,
            [...newAttributes, ...customAttributesValues], // Make sure already updated attrs go first in order to influence their dependants
          );

          let newQuantity2set = -1;
          if (oldDepAttrType.hasQuantity) {
            newQuantity2set = bIsAttributeEnabled ? oldDepAttribute.attributeQuantity : 0;
          }

          if (!bIsAttributeEnabled) {
            switch (oldDepAttrType.type) {
              case CustomAttributeType.Text:
                attrValue = '';
                break;
              case CustomAttributeType.Boolean:
                attrValue = 'false';
                break;
              case CustomAttributeType.Decimal:
                attrValue = '0.0';
                break;
              case CustomAttributeType.Integer:
                attrValue = '0';
                break;
              case CustomAttributeType.Option:
                attrValue = '';
                break;
              default:
                attrValue = oldDepAttribute.attributeValue;
            }
          }
          newAttributes.push({
            attributeKey: oldDepAttribute.attributeKey,
            attributeName: oldDepAttribute.attributeName,
            attributeValue: attrValue,
            attributeTranslatedValue: CustomAttributeData.getTranslatedOption(oldDepAttribute.attributeValue, oldDepAttrType),
            attributeQuantity: newQuantity2set,
            attributeBasePrice: attribute.basePrice,
            attributeEnabled: bIsAttributeEnabled,
          });
        }
      });
      changeCustomAttributesHandler([...newAttributes]);
    }
  };

  const renderCustomAttributes = () => {

    const attributesToRender = [...customAttributes]
      .sort((a, b) => (a.priority - b.priority) || (a.name?.localeCompare(b.name || '') || 0))
      .filter((attribute) => {
        const attrVal = customAttributesValues.find((aV) => aV.attributeKey === attribute.key);
        return attrVal ? attrVal.attributeEnabled : false;
      });

    /* eslint-disable jsx-a11y/click-events-have-key-events,
    jsx-a11y/no-noninteractive-element-interactions */
    return (
      <div className={`${className} container`} key="cust-attr-container">
        <p key={strings.CUSTOM_ATTRIBUTES} style={{ fontWeight: 'bold', fontSize: '1.5em' }} className="group">{strings.CUSTOM_ATTRIBUTES}</p>
        {attributesToRender?.map((attribute) => {

          const valueToBe = getAttributeValue(attribute.key);
          const quantityToBe = getAttributeQuantity(attribute.key, valueToBe);

          // ----------------------------------------------------------------------
          // Get the conditional ranges if they exist for this attribute
          // ----------------------------------------------------------------------
          const conditionalRange = ConditionalRangeRuleSet.getConditionalRange(
            attribute.conditionalRangeRuleSet,
            customAttributesValues,
          );

          const [conditionalRangeMin, conditionalRangeMax] = [conditionalRange?.min, conditionalRange?.max];

          if (bCheckForExtras && (CustomAttributeData.isFromClass(attribute, CustomAttributeClassPrefix.Extra)
              || CustomAttributeData.isFromClass(attribute, CustomAttributeClassPrefix.Extension))) {
            return null;
          }

          if (attribute.type === CustomAttributeType.Separator) {
            let localizedHyperLink: string = attribute.hyperLink;
            if (attribute.hyperLink && attribute.hyperLink !== '') {
              localizedHyperLink = attribute.hyperLink.replace('<$LANG>', lang);
            }
            return (
              <React.Fragment key={`sep-${attribute.key}`}>
                {' '}
                {localizedHyperLink && localizedHyperLink !== '' ? (
                  <p
                    key={`x-${attribute.key}`}
                    onClick={() => {
                      setIframeSrc(localizedHyperLink);
                      setIframeTitle(attribute.name ? attribute.name : 'Info');
                    }}
                    style={{
                      textAlign: 'center',
                      marginBottom: '5px',
                      marginTop: '15px',
                      color: attribute.color,
                      cursor: 'pointer',
                    }}
                  >
                    <b style={{ color: attribute.color, textDecoration: 'underline' }}>{attribute.name}</b>
                  </p>
                ) : (
                  <p
                    key={`y-${attribute.key}`}
                    style={{
                      textAlign: 'center',
                      marginBottom: '5px',
                      marginTop: '15px',
                      color: attribute.color,
                    }}
                  >
                    <b style={{ color: attribute.color, textDecoration: 'none' }}>{attribute.name}</b>
                  </p>
                )}
                <div
                  key={`z-${attribute.key}`}
                  style={{
                    borderTop: '2px solid #444444',
                    marginBottom: '15px',
                  }}
                />
              </React.Fragment>
            );
          }

          return (
            <div className="row justify-content-left" key={`CustomAttributeInput-${attribute.key}`} style={{ marginTop: '5px' }}>
              {attribute.type === CustomAttributeType.Option && (
              <ComponentCustomAttributeOption
                attribute={attribute}
                value={valueToBe}
                quantity={quantityToBe}
                onValueChanged={(value: string) => { fillAttributeValue(value, attribute.key); }}
                onQuantityChanged={(value: number) => { fillAttributeQuantity(value, attribute.key); }}
                editable={true}
                priceCurrencySymbol="€"
                priceData={priceData}
                conditionalRangeMax={conditionalRangeMax}
                conditionalRangeMin={conditionalRangeMin}
              />
              )}
              {attribute.type === CustomAttributeType.Boolean && (
              <ComponentCustomAttributeBoolean
                attribute={attribute}
                value={valueToBe}
                quantity={quantityToBe}
                onValueChanged={(value: string) => { fillAttributeValue(value, attribute.key); }}
                onQuantityChanged={(value: number) => { fillAttributeQuantity(value, attribute.key); }}
                editable={true}
                priceCurrencySymbol="€"
                priceData={priceData}
              />
              )}
              {attribute.type === CustomAttributeType.Text && (
              <ComponentCustomAttributeText
                attribute={attribute}
                value={valueToBe}
                onValueChanged={(value: string) => { fillAttributeValue(value, attribute.key); }}
                editable={true}
              />
              )}
              {attribute.type === CustomAttributeType.Integer && (
              <ComponentCustomAttributeInteger
                attribute={attribute}
                value={valueToBe}
                onValueChanged={(value: string) => { fillAttributeValue(value, attribute.key); }}
                editable={true}
                conditionalRangeMax={conditionalRangeMax}
                conditionalRangeMin={conditionalRangeMin}
              />
              )}
              {attribute.type === CustomAttributeType.Decimal && (
              <ComponentCustomAttributeDecimal
                attribute={attribute}
                value={valueToBe}
                onValueChanged={(value: string) => { fillAttributeValue(value, attribute.key); }}
                editable={true}
                conditionalRangeMax={conditionalRangeMax}
                conditionalRangeMin={conditionalRangeMin}
              />
              )}
            </div>
          );
        })}
        {/* Hyperlink attributes: Only render the iframe if iframeSrc is not defined */}
        <IframePopupComponent iframeSrc={iframeSrc} iframeTitle={iframeTitle} onClose={() => setIframeSrc('')} />
      </div>
    );
  };

  const customLineAttributes = customAttributes;

  return (
    <div className="xyz" key="maincustomattrs">
      {customLineAttributes && customLineAttributes.length > 0 && renderCustomAttributes()}
    </div>
  );
}
